import { Button } from '@opendoor/atoms/button';

interface NearMeButtonProps {
  city?: string | null;
  count?: number | null;
}

const formatCityName = (slug: string): string => {
  return slug
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const CityNearMeButton: React.FC<NearMeButtonProps> = ({ city, count }) => {
  if (!city || !count) {
    return (
      <Button
        analyticsName="zero-homes-disabled-placeholder"
        variant="secondary"
        aria-label="No homes near you"
        disabled
      >
        No homes near you
      </Button>
    );
  }

  const label = `${count} ${count === 1 ? 'home' : 'homes'} near you in ${formatCityName(city)}`;

  return (
    <Button
      analyticsName="count-homes-near-you"
      href={`/homes/${city}`}
      variant="primary"
      aria-label={label}
    >
      {label}
    </Button>
  );
};
